import { RouteConfig } from "vue-router";
import store from "@/store";
import { Roles } from "../models/emums/roles";

const routes: Array<RouteConfig> = [
    {
        path: "/mailing",
        component: require("@/layouts/layout.vue").default,
        children: [
            {
                path: "carrier-form",
                name: "Mailing list carrier form",
                component: require("@/components/mailing/mailing-list-carrier-form.vue").default,
                meta: {
                    roles: [Roles.Admin, Roles.User]
                },
            }
        ]
    }
];

export default routes;
